import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ClipboardList, Search, PenLine, Scale, Layers } from 'lucide-react';
const modules = [{
  num: 1,
  emoji: '📘',
  icon: BookOpen,
  title: 'Manual de Gestión Integral del Consultorio',
  desc: 'Scripts de comunicación, formularios de admisión y modelos de fichas para organizar tu práctica desde el primer día.'
}, {
  num: 2,
  emoji: '📋',
  icon: ClipboardList,
  title: 'Pack de Formularios y Documentos Clínicos',
  desc: 'Consentimientos informados, anamnesis y fichas de sesión listos para imprimir, completar y archivar sin redactar nada desde cero.'
}, {
  num: 3,
  emoji: '🔍',
  icon: Search,
  title: 'Sistema de Seguimiento de Pacientes',
  desc: 'Estructuras de seguimiento y modelos de registro para mantener el historial de cada paciente claro, ordenado y siempre actualizado.'
}, {
  num: 4,
  emoji: '✍️',
  icon: PenLine,
  title: 'Modelos de Informes y Documentación Técnica',
  desc: 'Estructuras pre-armadas para informes, derivaciones y constancias listas para completar y entregar en minutos.'
}, {
  num: 5,
  emoji: '⚖️',
  icon: Scale,
  title: 'Gestión de Honorarios y Encuadre Profesional',
  desc: 'Scripts para comunicar honorarios, manejar aumentos y responder situaciones difíciles con claridad y firmeza.'
}];
export function ModulesSection() {
  return <section className="py-16 md:py-24 bg-transparent pt-[30px] pb-[30px]" data-id="element-117">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-118">
        <div className="text-center mb-10" data-id="element-119">
          <span className="inline-flex items-center gap-2 px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#4A553F] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-120">
            <Layers className="w-4 h-4 text-[#d4a017]" data-id="element-121" />5 Módulos Incluidos
          </span>
          <h2 className="font-heading font-bold text-[#2f3a2c] text-3xl md:text-5xl leading-tight" data-id="element-122">
            Todo el sistema en{' '}
            <span className="italic text-[#5C6851]" data-id="element-123">
              5 módulos listos para usar
            </span>
          </h2>
        </div>

        <div className="space-y-5" data-id="element-124">
          {modules.map((m, i) => {
          const Icon = m.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex items-start gap-5 bg-white border border-slate-200 rounded-2xl p-6 md:p-7 shadow-sm" data-id="element-125">
                <div className="flex-shrink-0 flex flex-col items-center gap-2" data-id="element-126">
                  <div className="w-14 h-14 rounded-2xl bg-[#f4efe2] border border-amber-100 flex items-center justify-center" data-id="element-127">
                    <Icon className="w-7 h-7 text-[#5C6851]" aria-hidden="true" data-id="element-128" />
                  </div>
                  <span className="text-[10px] font-bold tracking-[0.15em] uppercase text-[#5C6851]" data-id="element-129">
                    Módulo {m.num}
                  </span>
                </div>
                <div data-id="element-130">
                  <h3 className="font-heading font-bold text-[#2f3a2c] text-xl md:text-2xl mb-2" data-id="element-131">
                    <span aria-hidden="true" className="mr-1" data-id="element-132">
                      {m.emoji}
                    </span>
                    {m.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-[15px] md:text-base" data-id="element-133">
                    {m.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}